<div class="painel pr-4 pl-4">
  <mat-list>
    <mat-list-item>
      <h1 class="text-uppercase font-weight-bold mb-0">Perfil</h1>
    </mat-list-item>

  </mat-list>
</div>

<div class="ativacoes  pr-4 pl-4">


  <div class="form-group">
    <b class="d-block">E-mail</b>
    {{user?.email}}
  </div>

  <div class="form-group">
    <b class="d-block">Nome</b>
    {{user?.nome}}
  </div>

  <div class="form-group">
    <b class="d-block">Empresa</b>
    {{user?.empresa?.nome}}
  </div>

  <div class="form-group" *ngIf="user?.status_bloqueio?.bloqueado">
    <b class="d-block">Status</b>
    {{user?.status_bloqueio.mensagem}}
  </div>

  <div class="form-group">
    <button (click)="resetarSenha()" class="btn btn-block  mb-2 text-uppercase"
      [ngClass]="'btn-action-' + user.empresa?.cor_lowercase.toLowerCase()">
      Resetar senha
    </button>
  </div>

  <div *ngIf="mensagem" class="alert alert-success">
    {{mensagem}}
  </div>



</div>
